export default "__VITE_ASSET__CHxhXP6z__"